import { render, staticRenderFns } from "./CancelBookingModal.vue?vue&type=template&id=ce004f2c"
import script from "./CancelBookingModal.vue?vue&type=script&lang=js"
export * from "./CancelBookingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports